const WA_LINK = "https://wa.me/243808631779?text=Bonjour%20je%20souhaite%20m'inscrire%20à%20une%20formation";
const FORM_URL = "https://readdy.ai/api/form/d7948kr86jhav3jpffag";

export default function ContactSection() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    try {
      await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      form.reset();
      alert('Message envoyé ! Nous vous contacterons bientôt.');
    } catch {
      alert('Erreur lors de l\'envoi. Veuillez réessayer.');
    }
  };

  return (
    <section id="contact" className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/71a41650fa15a863856377ca2abb31ee.jpg"
          alt="Campus Négus Tech"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0a1628]/85"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          {/* Left: Info */}
          <div className="flex-1">
            <span className="inline-block bg-[#f5c518]/20 text-[#f5c518] text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
              Contactez-nous
            </span>
            <h2 className="text-4xl md:text-6xl font-black text-white leading-tight mb-6">
              Rejoignez<br />
              <span className="text-[#f5c518]">Campus</span><br />
              Négus Tech
            </h2>
            <p className="text-white/70 text-lg leading-relaxed mb-10 max-w-md">
              Prêt à transformer votre avenir ? Contactez-nous via WhatsApp pour une réponse immédiate ou remplissez le formulaire ci-contre.
            </p>

            {/* Contact Info */}
            <div className="flex flex-col gap-5 mb-10">
              {[
                { icon: 'ri-whatsapp-line', label: 'WhatsApp', value: '+243 808 631 779', href: WA_LINK },
                { icon: 'ri-map-pin-line', label: 'Adresse', value: 'Kinshasa, République Démocratique du Congo', href: '#' },
                { icon: 'ri-time-line', label: 'Horaires', value: 'Lun–Sam : 8h00 – 20h00', href: '#' },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  target={item.href !== '#' ? '_blank' : undefined}
                  rel="noopener noreferrer"
                  className="flex items-center gap-4 group cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-[#f5c518]/20 rounded-xl group-hover:bg-[#f5c518]/40 transition-colors duration-200">
                    <i className={`${item.icon} text-[#f5c518] text-xl`}></i>
                  </div>
                  <div>
                    <div className="text-white/50 text-xs uppercase tracking-wider">{item.label}</div>
                    <div className="text-white font-semibold text-sm">{item.value}</div>
                  </div>
                </a>
              ))}
            </div>

            {/* Big WhatsApp CTA */}
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#f5c518] text-[#0a1628] font-black text-lg px-10 py-5 rounded-full hover:bg-yellow-400 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <div className="w-7 h-7 flex items-center justify-center bg-[#0a1628] rounded-full">
                <i className="ri-whatsapp-line text-[#f5c518] text-base"></i>
              </div>
              Contacter via WhatsApp
            </a>
          </div>

          {/* Right: Form */}
          <div className="w-full lg:w-[480px] bg-white rounded-3xl p-8">
            <h3 className="text-[#0a1628] font-black text-2xl mb-2">Demande d'information</h3>
            <p className="text-gray-500 text-sm mb-6">Remplissez ce formulaire et nous vous répondrons rapidement.</p>

            <form
              data-readdy-form
              id="contact-campus-negus"
              onSubmit={handleSubmit}
              className="flex flex-col gap-4"
            >
              <div>
                <label className="block text-[#0a1628] text-sm font-semibold mb-1.5">Nom complet *</label>
                <input
                  type="text"
                  name="nom"
                  required
                  placeholder="Votre nom et prénom"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-800 focus:outline-none focus:border-[#0a1628] transition-colors"
                />
              </div>
              <div>
                <label className="block text-[#0a1628] text-sm font-semibold mb-1.5">Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="votre@email.com"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-800 focus:outline-none focus:border-[#0a1628] transition-colors"
                />
              </div>
              <div>
                <label className="block text-[#0a1628] text-sm font-semibold mb-1.5">Téléphone / WhatsApp *</label>
                <input
                  type="tel"
                  name="telephone"
                  required
                  placeholder="+243 XXX XXX XXX"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-800 focus:outline-none focus:border-[#0a1628] transition-colors"
                />
              </div>
              <div>
                <label className="block text-[#0a1628] text-sm font-semibold mb-1.5">Formation souhaitée *</label>
                <select
                  name="formation"
                  required
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-800 focus:outline-none focus:border-[#0a1628] transition-colors cursor-pointer"
                >
                  <option value="">Choisir une formation</option>
                  <option>Électricité</option>
                  <option>Énergie Solaire</option>
                  <option>Fibre Optique</option>
                  <option>Téléphonie GSM</option>
                  <option>Sécurité & CCTV</option>
                  <option>Développement Web</option>
                  <option>Intelligence Artificielle</option>
                  <option>Business & Entrepreneuriat</option>
                </select>
              </div>
              <div>
                <label className="block text-[#0a1628] text-sm font-semibold mb-1.5">Message</label>
                <textarea
                  name="message"
                  rows={3}
                  maxLength={500}
                  placeholder="Votre message ou question..."
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-800 focus:outline-none focus:border-[#0a1628] transition-colors resize-none"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-[#0a1628] text-white font-bold text-sm py-4 rounded-xl hover:bg-[#0d1f3c] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                Envoyer ma demande
              </button>
            </form>

            <div className="mt-4 text-center">
              <span className="text-gray-400 text-xs">ou directement via</span>
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 mt-2 text-green-600 font-semibold text-sm hover:text-green-700 transition-colors cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-lg"></i>
                </div>
                WhatsApp — Réponse immédiate
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
